module.exports = __webpack_public_path__ + "img/bg3.d200bbec.png";